var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "title-btn" },
        [
          _c("div", { staticClass: "md-headline" }, [_vm._v("Series")]),
          _c(
            "md-button",
            {
              staticClass: "md-icon-button",
              attrs: { id: "btnClean" },
              on: { click: _vm.unselectedSerie }
            },
            [_c("md-icon", { attrs: { "md-iconset": "fa fa-eraser" } })],
            1
          )
        ],
        1
      ),
      _c("serie-selector", {
        on: { onSerieSelectorChange: _vm.onSerieSelectorChange },
        model: {
          value: _vm.entity.serie,
          callback: function($$v) {
            _vm.$set(_vm.entity, "serie", $$v)
          },
          expression: "entity.serie"
        }
      }),
      !_vm.isMiniSerie
        ? _c(
            "md-input-container",
            {
              class: {
                "md-input-invalid": _vm.formSubmitted && _vm.seasonNumberError
              }
            },
            [
              _c("label", [_vm._v("Season Number")]),
              _c("md-input", {
                ref: "seasonNumber",
                attrs: {
                  type: "number",
                  min: "0",
                  max: "100",
                  disabled: _vm.entity.serie === null || _vm.isMiniSerie
                },
                on: { change: _vm.onSeasonSelect },
                model: {
                  value: _vm.entity.seasonNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.entity, "seasonNumber", $$v)
                  },
                  expression: "entity.seasonNumber"
                }
              }),
              _vm.formSubmitted && _vm.seasonNumberError
                ? _c("span", { staticClass: "md-error" }, [
                    _vm._v("This field is required")
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "md-input-container",
        {
          class: {
            "md-input-invalid": _vm.formSubmitted && _vm.episodeNumberError
          }
        },
        [
          _c("label", [_vm._v("Episode Number")]),
          _c("md-input", {
            attrs: {
              type: "number",
              min: "0",
              max: "100",
              disabled: _vm.entity.serie === null
            },
            on: { change: _vm.onEpisodeSelect },
            model: {
              value: _vm.entity.episodeNumber,
              callback: function($$v) {
                _vm.$set(_vm.entity, "episodeNumber", $$v)
              },
              expression: "entity.episodeNumber"
            }
          }),
          _vm.formSubmitted && !isNaN(_vm.entity.episodeNumber)
            ? _c("span", { staticClass: "md-error" }, [
                _vm._v("This field is required")
              ])
            : _vm._e()
        ],
        1
      ),
      _vm.episodeFieldError
        ? _c("span", { staticClass: "md-error" }, [
            _vm._v("Episode number was already taken")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64399b1e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64399b1e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/ContentSerieForm.vue
// module id = 955
// module chunks = 0